import React, { Component } from "react";
import { observer, inject } from "mobx-react";
import { toast } from "react-toastify";
import config from "../config";
import Http from "axios";

@inject("UserStore", "AdminStore")
@observer
class Address extends Component {
  state = {
    addresses: {
      address1: "",
      address2: ""
    },
    phone: ""
  };

  editProfile = () => {
    if (
      this.state.addresses.address1 ||
      this.state.addresses.address2 ||
      this.state.phone
    ) {
      Http.post(
        config.api + "/editProfile",
        {
          addresses: {
            address1:
              this.state.addresses.address1 ||
              this.props.UserStore.user.addresses.address1,
            address2:
              this.state.addresses.address2 ||
              this.props.UserStore.user.addresses.address2
          },
          phone: this.state.phone || this.props.UserStore.user.phone
        },
        {
          withCredentials: true
        }
      )
        .then(user => {
          toast.info("Updated profile successfully!");
          this.setState({
            addresses: {
              address1: "",
              address2: ""
            },
            phone: ""
          });
          this.props.UserStore.getMyStats();
        })
        .catch(err => {});
    }
  };

  render() {
    const { UserStore, AdminStore, admin } = this.props;
    const user = admin ? AdminStore.userProfile : UserStore.user;
    return user ? (
      <div>
        <div className="acc-tabs-view">
          <div className="inputs-row">
            <p className="inp-title">Account Details</p>
            <div className="inps-holder">
              <div className="inp-con">
                <p>First Name:</p>
                <p style={{ width: "80%" }}>{user.firstName}</p>
              </div>
              <div className="inp-con">
                <p>Last Name:</p>
                <p style={{ width: "80%" }}>{user.lastName}</p>
              </div>
              <div className="inp-con">
                <p>Email:</p>
                <p style={{ width: "80%" }}>{user.email}</p>
              </div>
              <div className="inp-con">
                <p>Address 1:</p>
                {user.addresses ? (
                  <input
                    type="text"
                    defaultValue={user.addresses.address1}
                    onChange={e =>
                      this.setState({
                        addresses: {
                          ...this.state.addresses,
                          address1: e.target.value
                        }
                      })
                    }
                  />
                ) : (
                  <input
                    type="text"
                    defaultValue=""
                    onChange={e =>
                      this.setState({
                        addresses: {
                          ...this.state.addresses,
                          address1: e.target.value
                        }
                      })
                    }
                  />
                )}
              </div>
              <div className="inp-con">
                <p>Address 2:</p>
                {user.addresses ? (
                  <input
                    type="text"
                    defaultValue={user.addresses.address2}
                    onChange={e =>
                      this.setState({
                        addresses: {
                          ...this.state.addresses,
                          address2: e.target.value
                        }
                      })
                    }
                  />
                ) : (
                  <input
                    type="text"
                    defaultValue=""
                    onChange={e =>
                      this.setState({
                        addresses: {
                          ...this.state.addresses,
                          address2: e.target.value
                        }
                      })
                    }
                  />
                )}
              </div>
              <div className="inp-con">
                <p>Phone:</p>
                <input
                  type="tel"
                  defaultValue={user.phone}
                  onChange={e =>
                    this.setState({
                      phone: e.target.value
                    })
                  }
                />
              </div>
            </div>
          </div>
        </div>
        <div className="btn-hold">
          <button onClick={this.editProfile}>UPDATE PERSONAL INFO</button>
        </div>
      </div>
    ) : null;
  }
}

export default Address;



// WEBPACK FOOTER //
// ./src/components/Address.js